import {Component, HostListener, Inject, OnInit, Sanitizer} from '@angular/core';
import {FormControl} from '@angular/forms';

import {MessangerConnectionService} from './messanger-connection.service';
import {ActivatedRoute, Router} from '@angular/router';
import {
  AddAdmin, AddMember,
  AddNewSessionKeys, CreateConversation, DeleteConversation, GetContactList,
  GetConversations, GetConversationsFull,
  GetFiles,
  GetMembersList,
  GetMessages,
  GetUpdatedPublicKeys, GetUserInfo, LeaveConversation, MarkAllReaded, MessageDelivered,
  MessagesReaded, RenameConversation,
  SessionKeyValue,
  Typing, UpdateContact, UpdateMemberNick
} from './request';
import {
  AddedMessageToConversation,
  AddedSessionKey,
  AddMemberToConversation,
  ConversationDeleted,
  ConversationLeaved,
  Conversations,
  Files,
  MembersList,
  Messages,
  NewPublicKey,
  NewSessionKey,
  RenameConversationNotification,
  ResponseObject,
  StatusMessage,
  TypingNotification,
  UpdatedPublicKeys,
  UpdatedMessageNotification,
  ContactList,
  CreatedConversation,
  UserInfo,
  ConversationAvatarChangedNotification,
  ConversationsFull, ConversationBlocked
} from './response';
import {
  Contact,
  ContactDisplay,
  Conversation,
  ConversationDisplay,
  FileDownload,
  FileDownloadDisplay, FileParams,
  Message,
  MessageDisplay,
  SessionKey,
  User
} from './model';
import {Subject} from "rxjs";
import {
  faChevronLeft,
  faPencilAlt,
  faFileDownload,
  faImages,
  faInfoCircle,
  faKey,
  faMale,
  faMicrophoneAlt,
  faPaperPlane,
  faPlayCircle,
  faPowerOff,
  faStop,
  faUserPlus
} from '@fortawesome/free-solid-svg-icons';
import {UploadImageComponent} from "./upload-image.component";
import {Title} from "@angular/platform-browser";
import * as mime from "mime-types";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {InformationComponent} from "./information.component";
import {VerificationComponent} from "./verification.component";
import {FingerprintComponent} from "./fingerprint.component";
import {MatSnackBar, MatSnackBarRef, MatSnackBarConfig} from '@angular/material/snack-bar';
import {WarningComponent} from "./warning.component";
import {MatSelectionList} from "@angular/material/list";
import {MyfingerprintComponent} from "./myfingerprint.component";
import {ViewFileComponent} from "./view-file.component";


import { MediaRecorder, register } from 'extendable-media-recorder';
import { connect } from 'extendable-media-recorder-wav-encoder';
import {AddParticipantComponent} from "./add-participant.component";
import { DOCUMENT } from '@angular/common';
import {EulaComponent} from "./eula.component";
import {FaqComponent} from "./faq.component";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent implements OnInit {
  faFileDownload = faFileDownload;
  faStop = faStop;
  faPlayCircle = faPlayCircle;
  faPaperPlane = faPaperPlane;
  faImages = faImages;
  faEdit = faPencilAlt;
  faPowerOff = faPowerOff;
  faMale = faMale;
  faChevronLeft = faChevronLeft;

  faUserPlus = faUserPlus;
  faKey = faKey;
  faInfoCircle = faInfoCircle;

  faMicrophoneAlt = faMicrophoneAlt;

  message = new FormControl('');

  conversations: ConversationDisplay[] = [];
  messages: MessageDisplay[] = [];
  messagesConversation: Map<string, MessageDisplay[]> = new Map();
  events$: Subject<any> = new Subject<any>();

  selectedConversation: ConversationDisplay = new ConversationDisplay();

  user: User = new User("", "", "", new Date(), new Date(), "", "");
  autofocus = false;
  sessionKeyAbsent = false;

  scrollDown = false;
  leftWidth: number = 40;
  rightWidth: number = 60;
  hideMessages: boolean = false;
  hideConversations: boolean = false;
  height516 = 516;
  height550 = 550;
  mediaRecorder:any = null;
  private privWidth: number = 1000;
  private typing: boolean = false;
  typings: string[] = [];
  private notificationSound:any = null;
  windowInnerHeight = 0;
  windowInnerWidth = 0;

  showCreateGroup = false;

  showContacts: boolean = false;
  showMenu:boolean = false;
  showSettings: boolean = false;
  showCreateConversation: boolean = false;
  contacts: ContactDisplay[] = [];
  contactsWithoutSupport: ContactDisplay[] = [];

  avatar: any = null;

  needSelectConversation: boolean = false;
  warningVerification: any = null;
  selectedContactsDisplay = "";
  record: boolean = false;

  laterCheck: Map<string,boolean> = new Map();

  files: File[]=[];

  images: Map<string,boolean> = new Map();


  constructor(private router: Router,public con: MessangerConnectionService, public route: ActivatedRoute | null,
              private titleService: Title, public dialog: MatDialog, private _snackBar: MatSnackBar,
              @Inject(DOCUMENT) public document: Document
              ) {


    // @ts-ignore
    window.mobileCheck = function() {
      let check = false;
      // @ts-ignore
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    };


    // if(this.isMobile()) {
    //   window.addEventListener('orientationchange', updateOrientation, false);
    //
    //
    //   function updateOrientation() {
    //
    //
    //     var vpwidth = 300;
    //     // @ts-ignore
    //     window.resizeTo(
    //       300,
    //       window.screen.availHeight
    //     );
    //     var viewport = document.querySelector("meta[name=viewport]");
    //     console.log(viewport);
    //     // return;
    //
    //     switch (window.orientation) {
    //       case 0: //portrait
    //         // @ts-ignore
    //         viewport.setAttribute('content', 'width=' + vpwidth + ', initial-scale=1')
    //         break;
    //       case 90: case -90: //landscape
    //         // @ts-ignore
    //         viewport.setAttribute('content', 'width=' + vpwidth + ', initial-scale=1')
    //         break;
    //       default:
    //         // @ts-ignore
    //         viewport.setAttribute('content', 'width=' + vpwidth + ', initial-scale=1')
    //         break;
    //     }
    //   }
    //
    //   window.addEventListener('orientationchange', updateOrientation, false);
    //
    // }

    this.user = con.user;

    this.notificationSound = new Audio();
    this.notificationSound.src = "/assets/notification.mp3?v" + Math.random();
    this.notificationSound.load();


    if (this.user == null) {
      this.user = new User("", "", "", new Date(), new Date(), "", "");
    }

    this.con.downloadAvatar(avatar => {
      this.avatar = avatar;
    });


    this.events$.forEach((event: any) => {
      switch (event.constructor) {
        case ConversationDisplay: {
          let conversation = event as ConversationDisplay;
          // if(conversation.members.length == 0) {
          //   setTimeout(()=>{
          //     this.events$.next(conversation);
          //   }, 500)
          //   break;
          // }
          if(conversation.members.length == 0) {
            setTimeout(()=> {
              this.events$.next(event);
            }, 200);
            break;
          }
          if(conversation.isDialog && conversation.members.length == 2 && conversation.members.find(m=> m == this.con.adminId) != undefined) {
            if(this.con.adminId != this.con.userId) {
              break;
            }
          }
          this.conversations = this.resortConversations([conversation].concat(this.conversations));
          // console.log(conversation);
          if (conversation.uuid == this.selectedConversation.uuid) {
            this.selectConversation(conversation);
          }

          if(this.needSelectConversation) {
            this.selectConversation(conversation);
            this.needSelectConversation = false;
          }
          break;
        }

        case SelectFirstConversation: {
          if(this.conversations.length>0) {
            this.selectConversation(this.conversations[0]);
          }
          break;
        }
        case TypingNotification: {
          let typingNotification = event as TypingNotification;
          if (this.selectedConversation.uuid == typingNotification.conversationUuid) {
            this.con.encryption.getNick(typingNotification.userId, typingNotification.conversationUuid,(nick:string) => {
              let c = this.contacts.find(c => c.contactId == typingNotification.userId);
              if(c != undefined) {
                this.typings.push(nick + " " + c.contactIdOpen);
              } else {
                this.typings.push(nick + " " + typingNotification.userId);
              }
              this.scrollDownContent();
              setTimeout(() => {
                this.typings = this.typings.filter((element) => {
                  if(c == undefined) {
                    if (element != nick + " " + typingNotification.userId) {
                      return true;
                    } else {
                      return false;
                    }
                  } else {
                    if (element != nick + " " +  c.contactIdOpen) {
                      return true;
                    } else {
                      return false;
                    }
                  }
                })
              }, 5000)
            })
          }

          break;
        }

        case UpdatedMessageNotification:  {

          let notification = event as UpdatedMessageNotification;
          if(this.selectedConversation.uuid == notification.conversationUuid) {
            this.messages.forEach((m: MessageDisplay, index: number) =>{
              if(m.uuid == notification.uuid) {
                m.readedMembers = notification.readedMembers;
                m.deliveredMembers = notification.deliveredMembers;
                if(notification.deleted) {
                  m.body = "Message was deleted by user"
                  m.files = [];
                  m.filesOrig = [];
                  m.hasFiles = false;
                }
              }
            });
          }
          try {
            //@ts-ignore
            this.messagesConversation.get(notification.conversationUuid).forEach((m: MessageDisplay, index: number) => {
              if (m.uuid == notification.uuid) {
                m.readedMembers = notification.readedMembers;
                m.deliveredMembers = notification.deliveredMembers;
                if (notification.deleted) {
                  m.body = "Message was deleted by user"
                  m.files = [];
                  m.filesOrig = [];
                  m.hasFiles = false;
                }
              }
            });
          } catch (e) {
              console.log(e);
          }

          break;
        }

        case ConversationAvatarChangedNotification:  {
          let conversationAvatarChangedNotification = event as ConversationAvatarChangedNotification;
          let conversation = this.conversations.filter(c => c.uuid == conversationAvatarChangedNotification.conversationUuid)[0];
          this.con.downloadAvatarForConversation(conversation,"", avatar => {
            conversation.image = avatar;
          })
          break;
        }

        case RenameConversationNotification: {
          let renameConversationNotification = event as RenameConversationNotification;
          const conversation =  this.conversations.find(c => c.uuid == renameConversationNotification.conversationUuid) as ConversationDisplay;
          if(conversation != undefined) {
            this.con.encryption.decryptBase64BySessionKey(renameConversationNotification.title, (decTitle:string) => {
              conversation.title = decTitle;
            });
          } else {
            setTimeout(()=> {
              this.events$.next(event);
            },100);
          }

          break;
        }

        case MarkRead : {
          let markRead = event as MarkRead;
          let messages = this.messagesConversation.get(markRead.uuid);
          if (messages != undefined) {
            messages.forEach(m => {
              if (m.readed == false) {
                m.readed = true;
                this.con.storage.saveMessage(m);
                let readedRequest = new MessagesReaded(m.conversationUuid, [m.uuid]);
                this.con.sendRequest(readedRequest, (status) => {

                })
              }
            });
          }
          this.selectedConversation.unreadedCounter = 0;
          this.calcUnread();
          break;
        }

        case ConversationDeleted: {
          let notification = event as ConversationDeleted;

          if (this.conversations.length > 0) {
            this.conversations = this.conversations.filter(c => c.uuid != notification.uuid);
            this.calcUnread();
          }
          break;


        }

        case AddMemberToConversation: {
          let notification = event as AddMemberToConversation;
          if(notification.conversation.isDialog) {
            let cd: ConversationDisplay = this.convertToConversationDisplay(notification.conversation);
            this.events$.next(cd);

            // setTimeout(() => {
            //   let cd: ConversationDisplay = this.convertToConversationDisplay(notification.conversation);
            //   this.events$.next(cd);
            // },1000);
          } else {
            let cd: ConversationDisplay = this.convertToConversationDisplay(notification.conversation);
            this.events$.next(cd);
          }
          break;

        }

        case ConversationBlocked: {
          console.log("ConversationBlocked");
          let notification = event as ConversationBlocked;
          location.reload();
          break;
        }

        case ConversationLeaved: {
          let notification = event as ConversationLeaved;

          if (notification.userId == this.con.userId) {
            if (this.conversations.length > 0) {
              this.conversations = this.conversations.filter(c => c.uuid != notification.uuid)
            }
          }
          break;
        }

        case NewSessionKey: {
          let notification = event as NewSessionKey;
          if (this.conversations.length > 0) {
            let conversation = this.conversations.filter(c => c.uuid == notification.sessionKey.conversationUuid)[0];
            conversation.sessionKeyUuid = notification.sessionKey.uuid;
            if (this.selectedConversation.uuid == notification.sessionKey.conversationUuid) {
              this.selectedConversation.sessionKeyUuid = notification.sessionKey.uuid;
              this.sessionKeyAbsent = false;
            }
          }

          break;
        }


        case MessageDisplay: {
          let message = event as MessageDisplay;
          let messages: MessageDisplay[] = [];
          if (this.messagesConversation.has(message.conversationUuid)) {
            messages = this.messagesConversation.get(message.conversationUuid) as MessageDisplay[];
          }

            messages = messages.filter(m => {
              if (m.uuid == message.uuid) {
                return false;
              }
              {
                return true;
              }
            });
            let already = messages.find(m => {
              if (m.uuid == message.uuid) {
                return true;
              }
              {
                return false;
              }
            });
          let conversation = this.conversations.find(c => c.uuid == message.conversationUuid);
            if (already == undefined) {
              messages.push(message);
              messages = this.resortMessages(messages);
              if (conversation != undefined) {
                // if (message.readed == false) {
                //   conversation.unreadedCounter = conversation.unreadedCounter + 1;
                // }
                if(conversation.lastMessage != undefined) {
                  if(conversation.lastMessageDisplay.created == null || conversation.lastMessageDisplay.created.getTime() < message.created.getTime()) {
                    conversation.lastMessage = message.created;
                    conversation.lastMessageDisplay = message;
                  }
                }
                this.conversations = this.resortConversations(this.conversations);
              }
              this.messagesConversation.set(message.conversationUuid, messages);

              if (this.selectedConversation.uuid == message.conversationUuid) {

                this.messages = this.messagesConversation.get(message.conversationUuid) as MessageDisplay[];

              //   if(this.selectedConversation.firstUnreadMessageUuid == null
              // || this.selectedConversation.firstUnreadMessageUuid == message.uuid)
              }

            }
          if (conversation != undefined && message.needUpdateUnreadCnt && message.readed == false) {
            conversation.unreadedCounter = conversation.unreadedCounter + 1;
          }

          this.calcUnread();
          break;
        }
      }
    });


  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.windowInnerHeight = window.innerHeight;
    this.windowInnerWidth = window.innerWidth;
    this.height516 = window.innerHeight - 34 - 140;
    this.height550 = window.innerHeight - 140;

    if (window.innerWidth <= 768 && this.privWidth > 768) {
      this.leftWidth = 100;
      this.rightWidth = 100;
      this.hideMessages = true;
      this.hideConversations = false;
      this.privWidth = window.innerWidth;
    } else {
      if (window.innerWidth > 768 && this.privWidth <= 768) {
        this.leftWidth = 40;
        this.rightWidth = 60;
        this.hideMessages = false;
        this.hideConversations = false;
        this.privWidth = window.innerWidth;

      }
    }
  }

  back() {

    if (window.innerWidth < 768) {
      this.hideConversations = false;
      this.hideMessages = true;
    }


  }

  selectConversation(conversation: ConversationDisplay) {
    this.messages = [];
    this.images = new Map();
    if(conversation == undefined) {
      this.selectedConversation = new ConversationDisplay();
      return;
    }
    this.conversations.forEach(c => {
      if(c.uuid != conversation.uuid) {
        c.selected = false;
      } else {
        c.selected = true;
      }
    })
    this.typings = [];
    this.hideMessages = false;
    if (window.innerWidth < 768) {
      this.hideConversations = true;
    }

    setTimeout(() => {

      let markAllReaded = new MarkAllReaded(conversation.uuid);

      this.con.sendRequest(markAllReaded, (resp) => {
        let c = this.conversations.find(c=> c.uuid == conversation.uuid)
        if(c !=undefined) {
          c.firstUnreadMessageUuid = null;
        }

        this.events$.next(new MarkRead(conversation.uuid));
      });


    }, 5000);


    // if (this.selectedConversation.uuid != conversation.uuid) {
    //   this.events$.next(new MarkRead(this.selectedConversation.uuid));
    // }
    this.selectedConversation = conversation;

    let messages = this.messagesConversation.get(conversation.uuid) as MessageDisplay[];
    if(messages != undefined ) {

      if(this.selectedConversation.firstUnreadMessageUuid == null
        || messages.find(m => m.uuid == this.selectedConversation.firstUnreadMessageUuid) != undefined) {
        this.messages = messages;
      }

    }



    this.loadForShow(conversation, null);



    this.sessionKeyAbsent = false;
    this.con.encryption.getSessionKey(conversation.uuid, conversation.sessionKeyUuid, (sessionKey: any) => {
      if (sessionKey == null) {
        this.sessionKeyAbsent = true;
      } else {
        let requestGetUpdatedPublicKeys = new GetUpdatedPublicKeys(conversation.uuid);
        this.con.sendRequest(requestGetUpdatedPublicKeys, (responseHandler) => {
          let responseUpdatedPublicKeys = responseHandler as UpdatedPublicKeys
          if (responseUpdatedPublicKeys.publicKeys.size > 0) {
            this.sessionKeyAbsent = true;
          }
        });
      }
    });


        if(this.warningVerification != null) {
          this.warningVerification.dismiss();
        }

        setTimeout(() => {

          let requestGetMembersList = new GetMembersList(this.selectedConversation.uuid);
          this.con.sendRequest(requestGetMembersList, (responseObject) => {
            let  membersList = responseObject as MembersList
            this.selectedConversation.members = membersList.admins.concat(membersList.members);


            let requestGetContactList = new GetContactList(this.con.userId);
            this.con.sendRequest(requestGetContactList, (responseContactList) => {
              let contacts = (responseContactList as ContactList).users.map(c => {
                let cd = new ContactDisplay("", "", "", "", "", "", null, "");
                cd.initBy(c, this.con.encryption);
                cd.avatarSrc = "/download/avatars/user-profile.jpeg"
                return cd;
              });

              let contactId: any = null;
              if (this.selectedConversation.isDialog) {
                contactId = this.selectedConversation.members.find(u => u != this.con.userId);

                let trusted = null;
                let findContact: any = null;
                try {
                  findContact = contacts.find(u => u.contactId == contactId)
                  if (findContact != null) {
                    if(findContact.trustedFingerprintEncrypted == null) {
                      this.verificationFingerprint(findContact, () => {
                      });
                    } else {

                      let requestGetUserInfo = new GetUserInfo(  findContact.contactId)
                      this.con.sendRequest(requestGetUserInfo,
                        (responseObject) => {
                          let responseUserInfo = responseObject as UserInfo
                          let fingerprintOpen = this.con.encryption.fingerprintByPublicKey(responseUserInfo.user.publicKeyBase64)
                          let trustedFingerprintOpen = this.con.encryption.decryptByMetaDataKey(findContact.trustedFingerprintEncrypted)
                          if(trustedFingerprintOpen != fingerprintOpen) {
                            this.verificationFingerprint(findContact, () => {
                            });
                          }
                        })


                    }
                  } else {
                    let nickEncrypted = this.con.encryption.encryptByMetaDataKey(contactId);
                    let contactIdEncrypted = this.con.encryption.encryptByMetaDataKey("");
                    let c = new Contact(contactId, contactIdEncrypted, nickEncrypted, null);
                    this.updateContact(c, () => {
                      let cd = new ContactDisplay("", "", "", "", "", "", null, "");
                      cd.initBy(c, this.con.encryption);
                      this.verificationFingerprint(cd, () => {
                      });
                    });
                  }
                } finally {
                  // if (trusted == null) {
                    // this.warningVerification = this._snackBar.openFromComponent(WarningComponent, {
                    //   verticalPosition: 'top'
                    // });
                    // this.warningVerification.onAction().subscribe(() => {
                    //   this.verificationFingerprint(findContact, () => {
                    //   });
                    // });
                  // }
                }
            } else {
                let absentContactIds = this.selectedConversation.members.filter(m=> {
                  if(contacts.find(c => c.contactId == m) != undefined) {
                    return false;
                  } else {
                    return true;
                  }

                })

                absentContactIds.forEach(contactId => {
                  let nickEncrypted = this.con.encryption.encryptByMetaDataKey(contactId);
                  let contactIdEncrypted = this.con.encryption.encryptByMetaDataKey("");
                  let c = new Contact(contactId, contactIdEncrypted, nickEncrypted, null);
                  this.updateContact(c,() => {
                    let cd = new ContactDisplay("", "", "", "", "", "", null, "");
                    cd.initBy(c, this.con.encryption);
                    this.verificationFingerprint(cd, () => {
                    });
                  });
                })
               contacts.filter(contact => {
                 return this.selectedConversation.members.find(c => c == contact.contactId) != undefined
               }).forEach(contact => {
                 if(contact.trustedFingerprintEncrypted == null){
                   this.verificationFingerprint(contact, () => {
                   });
                 } else {

                   let requestGetUserInfo = new GetUserInfo(  contact.contactId)
                   this.con.sendRequest(requestGetUserInfo,
                     (responseObject) => {
                       let responseUserInfo = responseObject as UserInfo
                       let fingerprintOpen = this.con.encryption.fingerprintByPublicKey(responseUserInfo.user.publicKeyBase64)
                       let trustedFingerprintOpen = this.con.encryption.decryptByMetaDataKey(contact.trustedFingerprintEncrypted)
                       if(trustedFingerprintOpen != fingerprintOpen) {
                         this.verificationFingerprint(contact, () => {
                         });
                       }
                     })

                 }
               })
              }
            });
          });




        }, 1000);


    try {

    } catch (e) {
      let sessionKeyUuid = this.con.encryption.extractSessionKeyUuidBase64(conversation.titleSrc);
      if(conversation.sessionKeyUuid != sessionKeyUuid) {
        this.con.encryption.encryptBase64BySessionKey(conversation.title, conversation.sessionKeyUuid,conversation.uuid,(titleEnc: string) => {
          let reqRenameConversation = new RenameConversation(conversation.uuid, titleEnc);
          this.con.sendRequest(reqRenameConversation, (responseObject)=>{

          })
        });
      }

    }



    this.downloadAvatarForConversationImpl(this.user.userId, conversation.uuid, (avatar) =>{
      let that = this
      function downloadAndUpload(sessionKeyUuid: string) {
        that.con.downloadAvatarImpl(avatarSrc => {
          that.con.encryption.encryptBySessionKey(avatarSrc, sessionKeyUuid, conversation.uuid,(r:string) => {
            let f = new File([r],"avatar.jpeg");
            that.con.uploadAvatarToConversation(f, conversation.uuid, ()=> {});
          });
        });

      }

      if(avatar == null) {
        downloadAndUpload(conversation.sessionKeyUuid);
      } else {
        try {
          let sessionKeyUuid = this.con.encryption.extractSessionKey(avatar);
          if(conversation.sessionKeyUuid != sessionKeyUuid) {
            downloadAndUpload(conversation.sessionKeyUuid);
          }
        } catch (e) {
            // console.log(e)
        }
      }
    });


  }

  downloadAvatarForConversationImpl(userId: string, conversationUuid: string, next: (avatar: any) => void) {

    let file$ = this.con.downloadFile("/download/avatars/" +  conversationUuid + userId.replace(/\//g,"_") + ".jpeg" + "?rnd=" + Math.random());
    file$.subscribe((results: ArrayBuffer) => {

      next(this.con.arrayBufferToString(results));

    }, error => {
      next(null);

    });
  }

  loadContacts() {
    let requestGetContactList = new GetContactList(this.con.userId);
    this.con.sendRequest(requestGetContactList, (responseContactList) => {
      this.contacts = (responseContactList as ContactList).users.map(c => {
        let cd = new ContactDisplay("", "", "", "", "", "", null, "");
        cd.initBy(c, this.con.encryption);
        cd.avatarSrc = "/download/avatars/user-profile.jpeg"
        return cd;
      }).filter(c => c.contactId != this.con.userId);
      this.contactsWithoutSupport = this.contacts.filter(c => c.contactId != this.con.supportId);
    });
  }

  createConversation() {
    this.hideConversations = true;
    this.showCreateConversation = true;
    this.loadContacts();
      //this.router.navigate(['/create-conversation']);

  }

  sendMessage() {
    if (this.message.value != '') {
      this.sendMessageImpl(this.message.value, this.selectedConversation.uuid, this.selectedConversation.sessionKeyUuid);
    }
  }

  logout() {
    deleteCookie("pwd");
    window.location.href = '/';

  }

  // reset () {
  //   this.connection.clear();
  //   window.location.href = '/';
  //
  // }
  keyDownFunction(event: any) {
    // console.log(event);
    if (this.typing == false) {
      this.typing = true;
      let typingRequest = new Typing(this.selectedConversation.uuid);
      this.con.sendRequest(typingRequest, (status) => {
        setTimeout(() => {
            this.typing = false;
          },
          5000
        )
      })
    }

    if (event.keyCode == 13 && event.shiftKey == false) {
      this.sendMessage();
    }
  }

  getFileExt(fileName: string) {
    return this.con.encryption.getFileExt(fileName);
  }

  getFileType(fileName: string) {
    return this.con.encryption.getFileType(fileName);

  }

  showFaq() {
    const faq = this.dialog.open(FaqComponent, {
      width: '600px',

    });
  }

  ngOnInit() {

    // let requestGetUserInfo = new GetUserInfo(this.con.supportId);
    // this.con.sendRequest(requestGetUserInfo,
    //   (responseObject) => {
    //     let responseUserInfo = responseObject as UserInfo;
    //     let fingerprintOpen = this.con.encryption.fingerprintByPublicKey(responseUserInfo.user.publicKeyBase64);
    //     console.log("Support " + fingerprintOpen);
    //   }
    // );
    // let requestGetUserInfo2 = new GetUserInfo(this.con.adminId);
    // this.con.sendRequest(requestGetUserInfo2,
    //   (responseObject) => {
    //     let responseUserInfo = responseObject as UserInfo;
    //     let fingerprintOpen = this.con.encryption.fingerprintByPublicKey(responseUserInfo.user.publicKeyBase64);
    //     console.log("Admin " + fingerprintOpen);
    //   }
    // );

    // Admin 7e538dd595d8e50b9db5d2f98a39f29b16f4243c582c58691daccba8924a523b
    // Support 409f18a6b0fcf40e95c3a7e2e5cffd20cec4f8bdc64bc64e8c1a0239fd13e35a

    let nickEncrypted = this.con.encryption.encryptByMetaDataKey("Support");
    let contactIdEncrypted = this.con.encryption.encryptByMetaDataKey("");
    let trustedFingerprintEncrypted = this.con.encryption.encryptByMetaDataKey("409f18a6b0fcf40e95c3a7e2e5cffd20cec4f8bdc64bc64e8c1a0239fd13e35a")
    let c = new Contact(this.con.supportId, contactIdEncrypted, nickEncrypted, trustedFingerprintEncrypted);

    this.updateContact(c, () => {

        this.loadContacts();


        this.onResize(null);
        if (this.con.encryption == null) {
          this.router.navigate(['/']);
        } else {

          this.initConversations();

          this.con.onNotification((notification: ResponseObject) => {
            if(notification != null) {
              switch (notification.constructor) {
                case AddedMessageToConversation: {
                  let notification_ = notification as AddedMessageToConversation;

                  let messageDelivered = new MessageDelivered(notification_.message.conversationUuid,notification_.message.uuid);
                  this.con.sendRequest(messageDelivered, (ok) => {});

                  if (notification_.message.userId != this.con.userId) {
                    this.playNotification();

                    this.con.encryption.getNick(notification_.message.userId, notification_.message.conversationUuid, (nick: string) => {
                      this.typings = this.typings.filter((element) => {
                        if (element != nick + " " + notification_.message.userId) {
                          return true;
                        } else {
                          return false;
                        }
                      })

                    })

                  } else {
                    notification_.message.readed = true;
                  }
                  let c = this.conversations.find(c=> c.uuid == notification_.message.conversationUuid)
                  if(c !=undefined && c.firstUnreadMessageUuid == null) {
                    if(this.con.userId != notification_.message.userId) {
                      c.firstUnreadMessageUuid = notification_.message.uuid;
                    }
                  }
                  let md = this.convertToMessageDisplay(notification_.message);
                  md.needUpdateUnreadCnt = true;
                  this.events$.next(md);
                  if (this.selectedConversation.uuid == notification_.message.conversationUuid) {
                    this.scrollDownContent(true);
                    setTimeout(() => {
                      this.events$.next(new MarkRead(this.selectedConversation.uuid));
                    }, 2000);

                  }

                  break;
                }
                case NewPublicKey: {
                  let notification_ = notification as NewPublicKey;
                  if (this.con.userId == notification_.userId) {
                    this.router.navigate(['/']);
                  }
                  break;
                }
                case NewSessionKey: {
                  this.events$.next(notification);
                  break;
                }

                case TypingNotification: {
                  this.events$.next(notification);
                  break;
                }

                case ConversationBlocked: {
                  this.events$.next(notification);
                  break;
                }


                case UpdatedMessageNotification: {
                  this.events$.next(notification);
                  break;
                }

                case RenameConversationNotification: {
                  this.events$.next(notification);
                  break;
                }
                case ConversationDeleted: {
                  this.events$.next(notification);
                  break;
                }

                case ConversationLeaved: {
                  this.events$.next(notification);
                  break;
                }

                case ConversationAvatarChangedNotification: {
                  this.events$.next(notification);
                  break;
                }

                case AddMemberToConversation: {
                  let notification_ = notification as AddMemberToConversation;
                  if (notification_.userId == this.con.userId) {
                    this.events$.next(notification);
                  }
                  break;
                }
              }
            }
          });


        }



    });


  }

  addUser() {
    const dialogRef = this.dialog.open(AddParticipantComponent, {
      width: '450px',
      data: {conversationUuid: this.selectedConversation.uuid}
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  refreshKeys() {
    this.refreshKeysImpl(this.selectedConversation);
  }

  mysubstring (str: string) {
    if(str == null || str == undefined) {
      return str;
    }
    let len = str.length;
    if(len <17) {
      return str + this.genSpace(17-len);
    } else {
      return str.substring(0, 17)
    }
  }
  genSpace(i:number) {
    let ret = "";
    while (i != 0) {
      ret = ret + " ";
      i = i -1;
    }
    return ret;
  }

  members() {
    const dialogRef = this.dialog.open(InformationComponent, {
      width: '450px',
      data: {conversationUuid: this.selectedConversation.uuid}
    });
    dialogRef.afterClosed().subscribe(result => {

    });
    // this.router.navigate(['/information/' + this.selectedConversation.uuid]);
  }

  checkScroll(position: any, scrollMe: HTMLDivElement) {

    // console.log(position + " " + scrollMe.scrollHeight);

    if (position == 0) {
      if (this.selectedConversation != null) {
        const messages = this.messagesConversation.get(this.selectedConversation.uuid);
        if (messages != null || messages != undefined) {
          if (messages.length > 0) {
            const fromMessageUuid = messages[0].uuid;
            this.loadMessages(this.selectedConversation.uuid, fromMessageUuid, (messagesFromServer: MessageDisplay[]) => {
              messagesFromServer.reverse().forEach(m => this.events$.next(m));
              if (messagesFromServer.length > 0) {
                setTimeout(() => {
                  scrollMe.scrollTop = 100;
                }, 500);
              }
            });
          }
        }
      }
    }
  }

  settings() {
    this.router.navigate(['/settings']);

  }


  leave() {

    let leaveRequest = new LeaveConversation(this.selectedConversation.uuid);
    this.con.sendRequest(leaveRequest, (ok) => {
      if(ok.constructor == StatusMessage) {
        const res = ok as  StatusMessage
        if(res.status == "error") {
          const config = new MatSnackBarConfig();
          config.verticalPosition = "top";
          this._snackBar.open(res.description, "OK", config);
        } else {
          setTimeout(()=> {
            if(this.conversations.length>0) {
              this.selectConversation(this.conversations[0]);
            }
          }, 500);
        }
      }
    });

  }



  delete() {
    let deleteRequest = new DeleteConversation(this.selectedConversation.uuid);
    this.con.sendRequest(deleteRequest, (ok) => {
        setTimeout(()=> {
          this.selectConversation(this.conversations[0]);
          },500
        )
    })

  }


  addImageModal() {

    const dialogRef = this.dialog.open(UploadImageComponent, {
      data: {
        uuid: this.selectedConversation.uuid,
        sessionKeyUuid: this.selectedConversation.sessionKeyUuid
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });


  }

  playAudio(f: FileDownloadDisplay, m: MessageDisplay)  {


    let file$ = this.con.downloadFile(f.downloadUrl);
    file$.subscribe((results: ArrayBuffer) => {
      f.bodyEncrypted = this.arrayBufferToBase64(results);
      f.decryptFull(this.con,m, () => {
        let audio = new Audio(URL.createObjectURL(f.body as Blob));
        audio.play();

      })

    });

  }

  playNotification() {
    this.notificationSound.play();
  }

  blobToFile(theBlob: Blob, fileName: string): File {
    var b: any = theBlob;
    b.lastModifiedDate = new Date();
    b.name = fileName;
    return <File>theBlob;
  }

  startRecordTimestamp = new Date().getTime()
  async asyncRecordAudio() {
    await register(await connect());
    const stream = await navigator.mediaDevices.getUserMedia({audio: true});
    this.mediaRecorder = new MediaRecorder(stream, {mimeType: 'audio/wav'});

    this.mediaRecorder.ondataavailable = (e:any) => {
      let now = new Date().getTime()
      let fileDuration = Math.round((now - this.startRecordTimestamp) / 1000);

      let files: File[] = [];
      files.push(this.blobToFile(new Blob([e.data]), "voice.wav"));
      this.con.uploadFiles(files, [new FileParams(0,0, fileDuration, e.data.size, null, mime.lookup("voice.wav") as string)],"", this.selectedConversation.uuid, this.selectedConversation.sessionKeyUuid, () => {

      });

    };
    this.mediaRecorder.start();
    this.startRecordTimestamp = new Date().getTime()



  }

  recordAudio() {
    this.record = true

    if(this.mediaRecorder == null) {
      this.asyncRecordAudio()
    } else {
      this.mediaRecorder.start();
      this.startRecordTimestamp = new Date().getTime()
    }


  }

  stopAudio() {
    this.mediaRecorder.stop();
    this.record = false


  }

  downloadImage(fCopy: FileDownloadDisplay, mCopy: MessageDisplay) {

    let that = this;

    let key = mCopy.uuid + mCopy.conversationUuid + fCopy.fileNameEncrypted
    if(!this.images.has(key)) {
      console.log("downloadImage")
      this.images.set(key, true);
      setTimeout(() => {
        let m = this.messages.find(x => x.uuid == mCopy.uuid) as MessageDisplay
        let f = m.files.find(x => x.fileNameEncrypted == fCopy.fileNameEncrypted) as FileDownloadDisplay
        let file$ = this.con.downloadFile(f.downloadUrl);
        file$.subscribe((results: ArrayBuffer) => {
          f.bodyEncrypted = this.arrayBufferToBase64(results);
          f.decryptFull(this.con,m, () => {

          })

        });
      }, 1000)


    }

    return true;
  }
  downloadFile(f: FileDownloadDisplay, m: MessageDisplay) {

      let file$ = this.con.downloadFile(f.downloadUrl);
      file$.subscribe((results: ArrayBuffer) => {
        f.bodyEncrypted = this.arrayBufferToBase64(results);
        f.decryptFull(this.con,m, () => {
          saveData(f.body, f.fileName);
        })

      });
    alert("The file is downloaded and decrypted. The file download process will start in a few seconds or minutes. Depending on the size of the file. Please wait.")

  }

  scrollDownContent(force:boolean = false) {
    if(this.selectedConversation.firstUnreadMessageUuid == null || force) {
      console.log("scroll")
      this.scrollDown = !this.scrollDown;
      setTimeout(() => {
        this.scrollDown = !this.scrollDown;
      }, 250);
      setTimeout(() => {
        this.scrollDown = !this.scrollDown;
      }, 500);
      setTimeout(() => {
        this.scrollDown = !this.scrollDown;
      }, 1000);
      setTimeout(() => {
        this.scrollDown = !this.scrollDown;
      }, 2000);

    }
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({behavior: 'smooth'});
  }


  private sendMessageImpl(message: string, conversationUuid: string, sessionKeyUuid: string) {

    this.con.sendMessage(message, conversationUuid, sessionKeyUuid, (addedMessage) => {
      this.message.setValue("");
    });
  }

  private loadConversations(f: (conversations: ConversationDisplay[], lastMessages: Message[], sessionKeys: SessionKey[]) => void) {
    let requestGetConversations = new GetConversationsFull();
    this.con.sendRequest(requestGetConversations,
      (responseObject) => {
          let responseConversations = responseObject as ConversationsFull
        // exclude blocked conversations
          responseConversations.conversations = responseConversations.conversations.filter(c => c.blocked == false);
        let conversations = (responseConversations as Conversations).conversations.sort((a, b) => {
          if (a.lastMessage.getTime() < b.lastMessage.getTime()) {
            return 1;
          }
          if (a.lastMessage.getTime() > b.lastMessage.getTime()) {
            return -1;
          }
          if (a.lastMessage.getTime() == b.lastMessage.getTime()) {
            return 0;
          }
          return  0;
        }).map(c => {
          let cd: ConversationDisplay = this.convertToConversationDisplay(c);
          let firstUnreadMessage = responseConversations.firstUnreadMessageUuid.filter(m=> m.conversationUuid == c.uuid);
          if(firstUnreadMessage.length > 0) {
              cd.firstUnreadMessageUuid = firstUnreadMessage[0].uuid;
          }
          return cd;
        });
        f(conversations, responseConversations.lastMessages, responseConversations.sessionKeys);
      }
    );


  }

  private convertToMessageDisplay(message: Message): MessageDisplay {
    let md = new MessageDisplay();
    md.body = 'Decoding...';
    md.initBy(message);
    if(message.deleted) {
      md.body = "Message was deleted by user";
      return md;
    }
    // let storedMessage = this.con.storage.getMessage(message.uuid);
    if (false) {
      // md = storedMessage;

    } else {
      if (message.hasFiles) {
        this.getFiles(md, (files: FileDownloadDisplay[]) => {
          md.files = files;
          this.con.storage.saveMessage(md);

        });
      } else {
        this.con.storage.saveMessage(md);
      }

    }
    this.con.encryption.decryptMessage(message, (body: string) => {
      md.body = body;
    });
    this.con.encryption.getNick(md.userId, message.conversationUuid, (nick: string) => md.userNick = nick);
    return md;
  }

  private refreshKeysImpl(conversation: ConversationDisplay) {
    this.con.encryption.destroyPublicKeys();
    let requestGetMemberList = new GetMembersList(conversation.uuid);
    this.con.sendRequest(requestGetMemberList, (responseObject) => {
      let memberList = responseObject as MembersList
      let users = memberList.members.concat(memberList.admins).filter(u => u != this.con.userId);
      let sessionKeyValue: SessionKeyValue = this.con.encryption.generateSessionKeyValue(this.con.userId, this.con.user.keyPairUuid );
      let sessionKeyValues = [sessionKeyValue];
      this.generateSessionKeyForUser(users, sessionKeyValues, conversation, sessionKeyValue.signatureBase64, sessionKeyValue.signerUserId,  sessionKeyValue.signerKeyPairUuid,() => {
        let requestAddNewSessionKeys = new AddNewSessionKeys(conversation.uuid, sessionKeyValues);
        this.con.sendRequest(requestAddNewSessionKeys, (responseAddedSessionKey) => {
//          this.sendMessageImpl("Session Key regenerated", conversation.uuid, responseAddedSessionKey.sessionKeyUuid);
        })
      })
    });
  }

  private generateSessionKeyForUser(users: string[], sessionKeyValues: SessionKeyValue[], conversation: ConversationDisplay,signatureBase64: string, signerId: string,  signerKeyPairUuid: string, next: () => void) {
    let userId = users.pop();
    this.con.encryption.sessionKeyForUser(conversation.uuid, "-1", userId, signatureBase64, signerId,  signerKeyPairUuid,(userSessionKey: SessionKeyValue) => {
      sessionKeyValues.push(userSessionKey);
      if (users.length > 0) {
        this.generateSessionKeyForUser(users, sessionKeyValues, conversation,signatureBase64, signerId, signerKeyPairUuid , next);
      } else {
        next();
      }

    });
  }

  private loadMessages(conversationUuid: string, fromMessageUuid: string| null, f: (messages: MessageDisplay[]) => void) {
    let requestGetMessages = new GetMessages(conversationUuid, fromMessageUuid);
    requestGetMessages.size = 30;
    this.con.sendRequest(requestGetMessages,
      (responseMessages) => {
        let messages = (responseMessages as Messages).messages.map(message => this.convertToMessageDisplay(message));
        f(messages.reverse());
      }
    );
  }

  private resortConversations(conversationDisplays: ConversationDisplay[]) {
    return conversationDisplays.sort((a, b) => {
      if (a.lastMessage.getTime() < b.lastMessage.getTime()) {
        return 1;
      }
      if (a.lastMessage.getTime() > b.lastMessage.getTime()) {
        return -1;
      }
      if (a.lastMessage.getTime() == b.lastMessage.getTime()) {
        return 0;
      }
      return 0;
    });
  }

  private resortMessages(messagesDisplay: MessageDisplay[]) {
    return messagesDisplay.sort((a, b) => {
      if (a.created.getTime() > b.created.getTime()) {
        return 1;
      }
      if (a.created.getTime() < b.created.getTime()) {
        return -1;
      }
      if (a.created.getTime() == b.created.getTime()) {
        return 0;
      }
      return 0;
    });
  }

  private convertToConversationDisplay(c: Conversation): ConversationDisplay {
    let cd: ConversationDisplay = new ConversationDisplay();
    cd.initBy(c, this.con.encryption);
    let requestGetMembersList = new GetMembersList(c.uuid);
    this.con.sendRequest(requestGetMembersList, (responseObject) => {
      let membersList = responseObject as MembersList
      cd.members = membersList.admins.concat(membersList.members);
      cd.members.forEach((userId) => {
        this.con.encryption.getNick(userId, c.uuid,(nick: string) => {
            if(this.con.bigBrother && this.con.adminId == userId) {
                // not add
            } else {
              if(nick != null) {
                if(userId == this.con.userId) {
                  cd.membersNick.push("me");
                } else {
                  cd.membersNick.push(nick);
                }
              } else {
                if(userId == this.con.userId) {
                  cd.membersNick.push("me");
                } else {
                  cd.membersNick.push(userId.substring(0, 7));
                }
              }
            }
        });
      });
      if (c.isDialog) {
        let userId = membersList.admins.filter(u => u != this.con.userId).filter(c => {
          if(this.con.bigBrother && this.con.adminId == c) {
            return false;
          } else {
            return true;
          }
        })[0];

        cd.isAdmin = true;
        this.con.downloadAvatarForConversation(cd, userId, avatar => {
          cd.image = avatar;
        })
        this.con.encryption.getNick(userId, c.uuid,(nick: string) => cd.title = nick);
      } else {

        this.con.downloadAvatarForConversation(cd,"", avatar => {
          cd.image = avatar;
        })

        if (membersList.admins.filter(u => u == this.con.userId).length > 0) {
          cd.isAdmin = true;
        }
      }
    });
    cd.lastMessageDisplay = new MessageDisplay();
    // cd.lastMessageDisplay.body = "";
    return cd;
  }

  private getFiles(message: MessageDisplay, next: (files: FileDownloadDisplay[]) => void) {


    let getFiles = new GetFiles(message.conversationUuid, message.uuid);
    this.con.sendRequest(getFiles, (responseObject) => {
      let response = responseObject as Files
      if (response.files.length == 0) {
        setTimeout(() => {
          this.getFiles(message, next);
        }, 1000);
      } else {
        this.loadFiles(message, response.files, [], (files: FileDownloadDisplay[]) => {
          next(files);
        });
      }
    })

  }

  private loadFiles(m: MessageDisplay, files: FileDownload[], filesDisplay: FileDownloadDisplay[], next: (files: FileDownloadDisplay[]) => void) {
    let f = files.pop() as FileDownload;
    let fileNameEncrypted: string = f.fileNameEncrypted;
    let fd = new FileDownloadDisplay(fileNameEncrypted, "", "", "", true, new FileParams(f.width, f.height, f.duration, f.size, f.previewFileNameEncrypted, f.mimeType), f.previewFileNameEncrypted, f.downloadUrl);

    // console.log(fd);

    fd.decrypt(this.con,m, () => {
      if(this.getFileType(fd.fileName) == "wav") {
        let file$ = this.con.downloadFile(f.downloadUrl);
        file$.subscribe((results: ArrayBuffer) => {
          fd.bodyEncrypted = this.arrayBufferToBase64(results);
        });
      }
      filesDisplay.push(fd);
      if (files.length == 0) {
        next(filesDisplay);
      } else {
        this.loadFiles(m,files, filesDisplay, next);
      }

    })




  }

  private arrayBufferToBase64(buffer: any) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  private calcUnread() {

    if(this.conversations.length == 0) {
      this.titleService.setTitle("Jetico Messenger (Open Beta)");
    } else {
      let cnt = this.conversations.map(c => {
        return c.unreadedCounter;
      }).reduce((accumulator, currentValue) => accumulator + currentValue);
      if (cnt == 0) {
        this.titleService.setTitle("Jetico Messenger (Open Beta)");
      } else {
        this.titleService.setTitle("(" + cnt + ") Jetico Messenger (Open Beta)");

      }
    }

  }

  createConversationImpl(isDialog = true, title:string | null = null, contacts: ContactDisplay[], next: () => void) {
    let sessionKeyValue: SessionKeyValue = this.con.encryption.generateSessionKeyValue(this.con.userId,this.con.user.keyPairUuid);
    let requestCreateConversation = new CreateConversation(isDialog, sessionKeyValue, null);


    this.con.sendRequest(requestCreateConversation, (responseObject) => {

      let responseCreatedConversation = responseObject as CreatedConversation

      let users = contacts.map(c => {
        return c.contactId;
      })

      if(this.con.bigBrother) {
        users.push(this.con.adminId);
      }

      if (isDialog == true) {
        this.addMember(users, true, responseCreatedConversation.conversation, sessionKeyValue.signatureBase64, sessionKeyValue.signerUserId,this.con.user.keyPairUuid , () => {
          next();
          this.initConversations()
        });
      } else {
        this.addMember(users, false, responseCreatedConversation.conversation, sessionKeyValue.signatureBase64, sessionKeyValue.signerUserId,this.con.user.keyPairUuid,() => {
          let sessionKeyUuid = responseCreatedConversation.conversation.sessionKeyUuid;
          let conversationUuid = responseCreatedConversation.conversation.uuid;
          this.con.encryption.encryptBase64BySessionKey(title, sessionKeyUuid,conversationUuid,(titleEnc: string) => {
            let reqRenameConversation = new RenameConversation(conversationUuid, titleEnc);
            this.con.sendRequest(reqRenameConversation, (responseObject)=>{
              next();
              this.initConversations()
            })
          });
        });
      }


      let sessionKeyUuid = responseCreatedConversation.conversation.sessionKeyUuid;
      this.con.encryption.encryptBase64BySessionKey(this.con.nickOpen, sessionKeyUuid, responseCreatedConversation.conversation.uuid,(nickEnc: string) => {
        let requestUpdateMemberNick = new UpdateMemberNick(responseCreatedConversation.conversation.uuid, this.con.userId, nickEnc);
        this.con.sendRequest(requestUpdateMemberNick, (ok) => {

        } );
      });


    });

  }

  addMember(selectedUsers: string[], admin: boolean, conversation: Conversation,signatureBase64: string, signerId: string,signerKeyPairUuid: string, next: () => void) {

    let selectedUser = selectedUsers.pop()
    this.con.encryption.sessionKeyForUser(conversation.uuid, conversation.sessionKeyUuid,
      selectedUser, signatureBase64, signerId,signerKeyPairUuid ,(userSessionKey: SessionKeyValue) => {
        let requestAddAdminOrMember = null;

        if(this.con.bigBrother && this.con.adminId == selectedUser) {
          requestAddAdminOrMember = new AddAdmin(conversation.uuid, conversation.sessionKeyUuid, userSessionKey);
        } else {
          if (admin) {
            requestAddAdminOrMember = new AddAdmin(conversation.uuid, conversation.sessionKeyUuid, userSessionKey);
          } else {
            requestAddAdminOrMember = new AddMember(conversation.uuid, conversation.sessionKeyUuid, userSessionKey);
          }
        }

        this.con.sendRequest(requestAddAdminOrMember, (respnseStatusMessage) => {

          if (selectedUsers.length == 0) {
            next();
          } else {
            this.addMember(selectedUsers, admin, conversation, signatureBase64, signerId,signerKeyPairUuid,next);
          }

        });

      });

  }

  verificationFingerprint(contact: ContactDisplay, next: () => void) {
    if(this.con.bigBrother && this.con.adminId == contact.contactId) {
      next();
    } else {
      if(this.user.userId == contact.contactId) {
        next();
        return;
      }
      if(!this.laterCheck.has(contact.contactId) && contact.contactId != this.con.userId) {
        this.laterCheck.set(contact.contactId, true);
        let requestGetUserInfo = new GetUserInfo(  contact.contactId)
        this.con.sendRequest(requestGetUserInfo,
          (responseObject) => {
            let responseUserInfo =  responseObject as UserInfo
            const fingerprintComponent = this.dialog.open(FingerprintComponent, {
              width: '600px',
              data: {
                contactId: contact.contactId,
                contactIdOpen:  contact.contactIdOpen,
                nickOpen:  contact.nickOpen,
                publicKeyBase64: responseUserInfo.user.publicKeyBase64
              }
            });

            fingerprintComponent.afterClosed().subscribe(result => {
              if(result) {

                let fingerprintOpen = this.con.encryption.fingerprintByPublicKey(responseUserInfo.user.publicKeyBase64)
                let trustedFingerprintEncrypted = this.con.encryption.encryptByMetaDataKey(fingerprintOpen)
                let c = new Contact(contact.contactId, contact.contactIdEncrypted,contact.nickEncrypted, trustedFingerprintEncrypted );
                this.updateContact(c, ()=> {
                  next();
                })
              } else {
                next();
              }
            });

          });
      } else {
        next()
      }


    }




  }


  createDialog(contact: ContactDisplay) {
    this.hideConversations = false;
    this.showCreateConversation = false;

    this.pleaseWait();
    const dialog = this.conversations.filter(c => {
      if(c.isDialog) {
        if(c.members.find(uuid => uuid ==contact.contactId)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    })
    if(dialog.length == 0) {
      this.createConversationWithCheckFingerprint([contact], () => {
        this.needSelectConversation = true;
        this.createConversationImpl(true, null, [contact], () => {
          // this.hideConversations = false;
          // this.showCreateConversation = false;
        });
      });
    } else {
      // this.hideConversations = false;
      // this.showCreateConversation = false;
      this.selectConversation(dialog[0]);
    }

  }


  private createConversationWithCheckFingerprint(contacts: ContactDisplay[], next: () => void) {
    let contact: any = null;
    if(contacts.length > 0) {
      contact = contacts.pop() as ContactDisplay;

      if(contact.trustedFingerprintEncrypted == null && contact.contactId != this.con.userId && !this.laterCheck.has(contact.contactId)) {
        this.laterCheck.set(contact.contactId, true);
        const verificationComponent = this.dialog.open(VerificationComponent, {
          width: '600px',
          data: {
            contactId: contact.contactId,
            contactIdOpen:  contact.contactIdOpen,
            nickOpen:  contact.nickOpen
          }
        });

        verificationComponent.afterClosed().subscribe(result => {
          if(result) {

            this.verificationFingerprint(contact, ()=> {
              this.laterCheck.delete(contact.contactId);
              this.createConversationWithCheckFingerprint(contacts, next);
            });
          } else {
            this.createConversationWithCheckFingerprint(contacts, next);
          }
        });
      } else {
        this.createConversationWithCheckFingerprint(contacts, next);
      }
    } else {
      next();
    }


  }



  selectContact(contact: ContactDisplay, selectedContacts: MatSelectionList) {
    this.selectedContactsDisplay   = selectedContacts.selectedOptions.selected.map( x => x.value.nickOpen).toString();
  }

  createChatGroup(selectedContactsList: MatSelectionList) {
    this.hideConversations = false;
    this.showCreateConversation = false;
    this.pleaseWait();

    let contacts: ContactDisplay[] = selectedContactsList.selectedOptions.selected.map( x => x.value);

    this.createConversationWithCheckFingerprint( Object.assign({}, contacts), () => {

      this.needSelectConversation = true;
      this.createConversationImpl(false, "New chat group", contacts, () => {
        // this.hideConversations = false;
        // this.showCreateConversation = false;
      });

    })

  }

  showFingerprint() {
    const fingerprintComponent = this.dialog.open(MyfingerprintComponent, {
      width: '600px',
      data: {
        nick: this.con.nickOpen,
        phone: this.con.userIdOpen,
        fingerprint: this.con.encryption.fingerprint()
      }
    });

    fingerprintComponent.afterClosed().subscribe(result => {

    });
  }

  viewFile(message: MessageDisplay, f:FileDownloadDisplay ) {
    let files =  message.files;
    let file = files.find(file => {
      if(file.previewFileNameEncrypted == f.fileNameEncrypted) {
        return true;
      } else {
        return false;
      }
    }) as FileDownloadDisplay
    this.downloadImage(file, message)
    const dialogRef = this.dialog.open(ViewFileComponent, {
      width: '950px',
      data: {
        message: message,
        file: file
      }
    });
  }

  upload() {
    // @ts-ignore
    document.getElementById("click").click();
  }


  onChange(event: any) {
    for(let i = 0; i< event.target.files.length; i++) {
      let ext = (event.target.files[i] as File).name.split(".")[1];
      if(ext.toLowerCase() == "jpg" || ext.toLowerCase() == "jpeg") {
        this.files.push(event.target.files[i]);
      } else {
        this.files = [];
        alert("Accept only JPEG format for avatar")
        return;
      }
    }
    this.uploadFiles(this.files);
  }


  uploadFiles(files: File[]) {
    if(files.length == 0) {
      this.files = [];

    } else {
      let file = files.pop();
      if(file != undefined) {
        let that = this
        file.arrayBuffer().then(bytes => {
          that.con.encryption.encryptBySessionKey(that.con.arrayBufferToString(bytes), that.selectedConversation.sessionKeyUuid, that.selectedConversation.uuid,(r:string) => {
            let f = new File([r],"avatar.jpeg");
            that.con.uploadConversationAvatar(f, that.selectedConversation.uuid, ()=> {
              that.uploadFiles(files);
            });
          });
        })
      }
    }
  }

  urlify(text:string):string {
    if(text != null) {
      let myString = new String(text);
      text = myString.replace(/<[^>]*>?/gm, '');
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlRegex, '<a target="_blank" href="$1">$1</a>')
    } else return text;
  }
  morestrip(text:string):string {
    if(text != null) {
      let ret = this.strip(text);
      ret = ret.replace(/\n/g, " ");
      ret = ret.replace("  ", " ");
      ret = ret.replace("   ", " ");
      ret = ret.replace("    ", " ");
      ret = ret.replace("     ", " ");
      ret = ret.replace("      ", " ");
      ret = ret.replace("       ", " ");
      return ret;
    } else return text;
  }

  strip(text:string):string {
    if(text != null) {
      let myString = new String(text);
      text = myString.replace(/<[^>]*>?/gm, '');
      return text;
    } else return text;
  }
  isAdmin() {
    return this.selectedConversation.isAdmin;
  }

  search() {
    this.router.navigate(['/search']);
  }
  searchByUuid(uuid: string) {
    this.router.navigate(['/search/'+uuid]);
  }

  private loadForShow(conversation: ConversationDisplay, fromMessage: MessageDisplay| null) {

      let from = null;
      if(fromMessage != null) {
        from = fromMessage.uuid;
      }
      this.loadMessages(conversation.uuid, null, (messages: MessageDisplay[]) => {
        if (messages.length > 0) {
          messages.reverse().forEach(m => {
            this.events$.next(m as MessageDisplay);
          });

          if(this.selectedConversation.firstUnreadMessageUuid != null) {
            if(messages.find(m=> m.uuid == this.selectedConversation.firstUnreadMessageUuid) == undefined) {
              this.loadForShow(conversation,messages[messages.length - 1]);
            } else {

              setTimeout(() => {
                let el = this.document.getElementById('message_' +this.selectedConversation.firstUnreadMessageUuid);
                if(el != null) {
                  this.scroll(el);
                }

              }, 500);


            }
          } else {
            this.scrollDownContent();

          }

        }
      });




  }

  calcWidth() {
    if( window.innerWidth>1024) {
      if(this.isMobile() == false) {
        return  "1024px";
      } else {
        return  "350px";
      }
    } else {

      if(this.isMobile() == false) {
        return window.innerWidth + "px";
      } else {
        return  "350px";
      }
    }
  }


  displayMessages() {
    if( window.innerWidth>600 && this.isMobile() == false) {
      return  "";
    } else {
      if(this.selectedConversation.uuid == "") {
        return "none";
      } else {
        return "";
      }
    }
  }

  displayNav() {
    if( window.innerWidth>600 && this.isMobile() == false) {
      return  "";
    } else {
      if(this.selectedConversation.uuid != "") {
        return "none";
      } else {
        return "";
      }
    }
  }

  openNav() {
    if( window.innerWidth>600 && this.isMobile() == false) {
      return  true;
    } else {
      if(this.selectedConversation.uuid == "") {
        return true;
      } else {
        return false;
      }
    }
  }

  needOpenNav() {
    this.hideConversations = false;
    this.selectedConversation = new ConversationDisplay();
  }

 isMobile() {
   // @ts-ignore
   return window.mobileCheck();
 }

  m11() {
    if( window.innerWidth>600 && this.isMobile() == false) {
      return "padding-right: 300px;"
    } else {
      return "";
    }
  }

  m12() {
    if( window.innerWidth>600 && this.isMobile() == false) {
      return "margin: 0 0 4px;padding: 4px 12px 9px 14px;"
    } else {
      return "";
    }
  }

  m21() {
    if( window.innerWidth>600 && this.isMobile() == false) {
      return "padding-left: 300px;"
    } else {
      return "";
    }
  }

  m22() {
    if( window.innerWidth>600 && this.isMobile() == false) {
      return "padding: 4px 9px 9px 14px;"
    } else {
      return "";
    }
  }

  areaSize() {
    if( window.innerWidth>600 && this.isMobile() == false) {
      return ""
    } else {
      if(this.message.value != '') {
        return "width: 400px;";
      } else {
        return "width: 100px;";
      }
    }

  }

  private updateContact(c: Contact, f: () => void) {

    if(this.con.userId != c.contactId) {
      let requestUpdateContact = new UpdateContact(this.con.userId, c);
      this.con.sendRequest(requestUpdateContact,
        (status) => {
          f();
        });
    } else {
      f();
    }


  }

  private initConversations() {
    this.conversations = [];
    this.loadConversations((conversations: ConversationDisplay[], lastMessages: Message[], sessionKeys: SessionKey[]) => {
      conversations.reverse().forEach(c => this.events$.next(c));
      setTimeout(()=> {
        lastMessages.forEach(m => {
          let message = this.convertToMessageDisplay(m);
          this.events$.next(message);
        });
        if(window.innerWidth>600 && this.isMobile() == false) {
          this.events$.next(new SelectFirstConversation());
        }
      }, 2000);

      sessionKeys.forEach(sessionKey => {
        this.con.encryption.getSessionKey(sessionKey.conversationUuid, sessionKey.uuid, (sessionKey: any) => {
        })
      });

    });
  }

  selectedConversationMembers() {
    const str = this.selectedConversation.membersNick.join(", ");
    if(str.length>80) {
      return str.substring(0, 80) +"...";
    } else {
      return str.substring(0, 80);
    }
  }

  private pleaseWait() {
    const config = new MatSnackBarConfig();
    config.verticalPosition = "top";
    this._snackBar.open("SessionKey for new chat is generated, please wait 2-3 seconds...", "OK", config);


  }
}


export class MarkRead {
  uuid: string = "";

  constructor(uuid: string) {
    this.uuid = uuid;
  }
}

export class SelectFirstConversation {

}


var saveData = (function () {
  var a = document.createElement("a");
  document.body.appendChild(a);
  // a.style = "display: none";
  return function (data: any, fileName: any) {
    console.log(data);
    var url = window.URL.createObjectURL(data);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };
}());

function setCookie(name: string, value: string, expires?: Date): void {
  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/`;

  if (expires) {
    cookieString += `; expires=${expires.toUTCString()}`;
  }

  document.cookie = cookieString;
}
// Удаление cookie
function deleteCookie(name: string): void {
  setCookie(name, '', new Date(0));
}

